export abstract class ErrorProvider {
  readonly applicationName!: string;
}